// Mathematics Unit Tests and Exercises - Years 11-13
// Based on Vanuatu National Syllabus

// Year 11 Mathematics Unit Tests
export const year11MathematicsUnitTests = {
  term1: {
    title: "Term 1 - Algebra",
    tests: [
      {
        title: "Unit Test 1: Expansion and Indices",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Short Answer", marks: 20, questions: 5 },
          { name: "Section C: Extended Response", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 2: Factorization",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Factorizing Expressions", marks: 20, questions: 8 },
          { name: "Section C: Problem Solving", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 3: Surds and Equations",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Simplifying Surds", marks: 15, questions: 5 },
          { name: "Section C: Solving Equations", marks: 20, questions: 4 }
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Geometry and Trigonometry",
    tests: [
      {
        title: "Unit Test 4: Triangle Trigonometry",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Calculations", marks: 20, questions: 5 },
          { name: "Section C: Application Problems", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 5: Circle Geometry",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Arc and Sector Calculations", marks: 20, questions: 5 },
          { name: "Section C: Problem Solving", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 6: Coordinate Geometry",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Distance and Gradient", marks: 20, questions: 5 },
          { name: "Section C: Equations of Lines", marks: 15, questions: 3 }
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Calculus and Statistics",
    tests: [
      {
        title: "Unit Test 7: Sequences and Series",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Finding Terms and Sums", marks: 20, questions: 5 },
          { name: "Section C: Word Problems", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 8: Differentiation",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Differentiating Functions", marks: 20, questions: 6 },
          { name: "Section C: Gradient and Tangent Problems", marks: 15, questions: 2 }
        ]
      },
      {
        title: "Unit Test 9: Probability and Statistics",
        duration: "45 minutes",
        totalMarks: 50,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Probability Calculations", marks: 15, questions: 5 },
          { name: "Section C: Statistical Analysis", marks: 20, questions: 3 }
        ]
      }
    ]
  }
};

// Year 12 Mathematics Unit Tests
export const year12MathematicsUnitTests = {
  term1: {
    title: "Term 1 - Advanced Algebra",
    tests: [
      {
        title: "Unit Test 1: Linear and Quadratic Equations",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Solving Equations", marks: 25, questions: 6 },
          { name: "Section C: Graphing and Analysis", marks: 20, questions: 3 }
        ]
      },
      {
        title: "Unit Test 2: Cubic and Rational Functions",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Factor Theorem Applications", marks: 25, questions: 5 },
          { name: "Section C: Graph Sketching", marks: 20, questions: 3 }
        ]
      },
      {
        title: "Unit Test 3: Exponentials and Logarithms",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Applying Laws", marks: 25, questions: 6 },
          { name: "Section C: Solving and Graphing", marks: 20, questions: 3 }
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Geometry and Calculus",
    tests: [
      {
        title: "Unit Test 4: Trigonometric Graphs",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Graph Transformations", marks: 25, questions: 5 },
          { name: "Section C: Solving Trig Equations", marks: 20, questions: 4 }
        ]
      },
      {
        title: "Unit Test 5: Circle Geometry",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Circle Equations", marks: 25, questions: 5 },
          { name: "Section C: Intersections", marks: 20, questions: 3 }
        ]
      },
      {
        title: "Unit Test 6: Sequences and Series",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: AP and GP Calculations", marks: 25, questions: 5 },
          { name: "Section C: Applications", marks: 20, questions: 3 }
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Calculus and Statistics",
    tests: [
      {
        title: "Unit Test 7: Differentiation",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Derivative Calculations", marks: 25, questions: 6 },
          { name: "Section C: Applications", marks: 20, questions: 3 }
        ]
      },
      {
        title: "Unit Test 8: Integration",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Integration Techniques", marks: 25, questions: 5 },
          { name: "Section C: Area Problems", marks: 20, questions: 3 }
        ]
      },
      {
        title: "Unit Test 9: Statistics and Normal Distribution",
        duration: "60 minutes",
        totalMarks: 60,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Statistical Analysis", marks: 25, questions: 5 },
          { name: "Section C: Normal Distribution", marks: 20, questions: 3 }
        ]
      }
    ]
  }
};

// Year 13 Mathematics Unit Tests
export const year13MathematicsUnitTests = {
  term1: {
    title: "Term 1 - Algebra and Complex Numbers",
    tests: [
      {
        title: "Unit Test 1: Advanced Algebra",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Binomial Theorem", marks: 20, questions: 4 },
          { name: "Section C: Mathematical Induction", marks: 20, questions: 2 },
          { name: "Section D: Partial Fractions", marks: 20, questions: 3 }
        ]
      },
      {
        title: "Unit Test 2: Complex Numbers",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Operations", marks: 25, questions: 6 },
          { name: "Section C: Argand Diagrams", marks: 15, questions: 3 },
          { name: "Section D: De Moivre's Theorem", marks: 20, questions: 2 }
        ]
      },
      {
        title: "Unit Test 3: Vectors",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Vector Operations", marks: 25, questions: 5 },
          { name: "Section C: Applications", marks: 35, questions: 4 }
        ]
      }
    ]
  },
  term2: {
    title: "Term 2 - Trigonometry and Calculus",
    tests: [
      {
        title: "Unit Test 4: Advanced Trigonometry",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Identities and Formulas", marks: 30, questions: 6 },
          { name: "Section C: Proving Identities", marks: 30, questions: 4 }
        ]
      },
      {
        title: "Unit Test 5: Advanced Differentiation",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Differentiation Techniques", marks: 30, questions: 6 },
          { name: "Section C: Applications", marks: 30, questions: 4 }
        ]
      },
      {
        title: "Unit Test 6: Limits and Continuity",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Evaluating Limits", marks: 30, questions: 6 },
          { name: "Section C: Continuity and Differentiability", marks: 30, questions: 4 }
        ]
      }
    ]
  },
  term3: {
    title: "Term 3 - Integration and Statistics",
    tests: [
      {
        title: "Unit Test 7: Integration Techniques",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Integration Methods", marks: 30, questions: 6 },
          { name: "Section C: Area and Volume", marks: 30, questions: 4 }
        ]
      },
      {
        title: "Unit Test 8: Differential Equations",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: First Order Equations", marks: 30, questions: 5 },
          { name: "Section C: Applications", marks: 30, questions: 3 }
        ]
      },
      {
        title: "Unit Test 9: Statistics and Hypothesis Testing",
        duration: "75 minutes",
        totalMarks: 75,
        sections: [
          { name: "Section A: Multiple Choice", marks: 15, questions: 15 },
          { name: "Section B: Binomial Distribution", marks: 25, questions: 4 },
          { name: "Section C: Hypothesis Testing", marks: 35, questions: 3 }
        ]
      }
    ]
  }
};

// Year 11 Mathematics Exercises
export const year11MathematicsExercises = {
  algebra: {
    title: "Algebra Exercises",
    exercises: [
      {
        title: "Exercise 1.1: Expansion Practice",
        type: "Practice",
        instructions: "Expand and simplify each expression",
        questions: [
          "Expand 3(x + 4)",
          "Expand (x + 5)²",
          "Expand (2x - 3)(x + 4)",
          "Expand (3x + 2)(3x - 2)",
          "Expand 2x(x² - 3x + 5)"
        ]
      },
      {
        title: "Exercise 1.2: Factorization Practice",
        type: "Practice",
        instructions: "Factorize each expression completely",
        questions: [
          "Factorize 6x + 12",
          "Factorize x² - 25",
          "Factorize x² + 7x + 10",
          "Factorize 2x² - 8x",
          "Factorize x² - 6x + 9"
        ]
      },
      {
        title: "Exercise 1.3: Surds Practice",
        type: "Practice",
        instructions: "Simplify each surd expression",
        questions: [
          "Simplify √72",
          "Simplify 3√2 + 5√2",
          "Simplify √3 × √27",
          "Rationalize 6/√3",
          "Simplify (√5 + 2)(√5 - 2)"
        ]
      }
    ]
  },
  trigonometry: {
    title: "Trigonometry Exercises",
    exercises: [
      {
        title: "Exercise 2.1: Trigonometric Ratios",
        type: "Practice",
        instructions: "Find the required values",
        questions: [
          "Find sin 45° (exact value)",
          "In a right triangle, opposite = 8, hypotenuse = 17. Find sin θ",
          "Find the angle if tan θ = 1",
          "Find cos 60° (exact value)",
          "In a right triangle with adjacent = 5 and hypotenuse = 13, find cos θ"
        ]
      },
      {
        title: "Exercise 2.2: Sine and Cosine Rules",
        type: "Application",
        instructions: "Use appropriate rules to solve",
        questions: [
          "In triangle ABC, a = 7, B = 50°, C = 70°. Find b.",
          "In triangle PQR, p = 8, q = 11, R = 40°. Find r.",
          "Find the area of triangle with sides 6 and 8, included angle 30°",
          "In triangle XYZ, x = 5, y = 7, z = 9. Find angle X.",
          "Two ships leave a port. One travels 15 km at bearing 040°, the other 20 km at bearing 130°. Find the distance between them."
        ]
      }
    ]
  },
  calculus: {
    title: "Calculus Exercises",
    exercises: [
      {
        title: "Exercise 3.1: Differentiation Basics",
        type: "Practice",
        instructions: "Differentiate each function",
        questions: [
          "y = x⁵",
          "y = 3x² + 2x - 7",
          "y = x³ - 4x² + x",
          "f(x) = 5x⁴ - 2x³ + 6",
          "f(x) = 1/x (hint: write as x⁻¹)"
        ]
      },
      {
        title: "Exercise 3.2: Gradient Problems",
        type: "Application",
        instructions: "Find the gradient at the given point",
        questions: [
          "y = x² at x = 3",
          "y = x³ - 2x at x = 2",
          "y = 4x² - x at x = -1",
          "Find points where y = x³ - 3x has gradient = 0",
          "Find equation of tangent to y = x² at point (2, 4)"
        ]
      }
    ]
  }
};

// Year 12 Mathematics Exercises
export const year12MathematicsExercises = {
  algebra: {
    title: "Advanced Algebra Exercises",
    exercises: [
      {
        title: "Exercise 1.1: Quadratic Equations",
        type: "Practice",
        instructions: "Solve each quadratic equation",
        questions: [
          "x² - 5x + 6 = 0",
          "2x² + 7x - 15 = 0",
          "x² - 4x - 1 = 0 (use quadratic formula)",
          "Find the discriminant and nature of roots: x² + 3x + 5 = 0",
          "Form a quadratic with roots 2 and -3"
        ]
      },
      {
        title: "Exercise 1.2: Cubic Functions",
        type: "Practice",
        instructions: "Use the factor theorem to factorize",
        questions: [
          "Show (x - 2) is a factor of x³ - 7x + 6",
          "Factorize x³ + 2x² - 5x - 6 completely",
          "Find the remainder when x³ + 3x² - 4 is divided by (x + 1)",
          "Solve x³ - 6x² + 11x - 6 = 0",
          "Sketch y = x³ - 3x showing all intercepts"
        ]
      }
    ]
  },
  calculus: {
    title: "Calculus Exercises",
    exercises: [
      {
        title: "Exercise 3.1: Integration Basics",
        type: "Practice",
        instructions: "Integrate each function",
        questions: [
          "∫ 4x³ dx",
          "∫ (3x² - 2x + 5) dx",
          "∫ (x + 1/x²) dx",
          "Find ∫₁³ 2x dx",
          "Find ∫₀² (x² + 1) dx"
        ]
      },
      {
        title: "Exercise 3.2: Area Under Curves",
        type: "Application",
        instructions: "Find the shaded area",
        questions: [
          "Area between y = x² and x-axis from x = 0 to x = 3",
          "Area between y = x³ and x-axis from x = 0 to x = 2",
          "Area enclosed by y = x² and y = 4",
          "Area between y = x² and y = x from x = 0 to x = 1",
          "Area enclosed by y = 6x - x² and the x-axis"
        ]
      }
    ]
  }
};

// Year 13 Mathematics Exercises
export const year13MathematicsExercises = {
  complexNumbers: {
    title: "Complex Numbers Exercises",
    exercises: [
      {
        title: "Exercise 2.1: Complex Number Operations",
        type: "Practice",
        instructions: "Simplify each expression",
        questions: [
          "Simplify i⁷",
          "Calculate (3 + 2i) + (5 - 4i)",
          "Calculate (2 + 3i)(4 - i)",
          "Find the conjugate and modulus of 5 - 12i",
          "Divide (4 + 3i) by (2 - i)"
        ]
      },
      {
        title: "Exercise 2.2: Polar Form and De Moivre",
        type: "Practice",
        instructions: "Convert and calculate",
        questions: [
          "Convert 1 + √3i to polar form",
          "Convert 2cis(π/3) to rectangular form",
          "Use De Moivre's theorem to find (1 + i)⁴",
          "Find the cube roots of 8",
          "Solve z² = -4"
        ]
      }
    ]
  },
  calculus: {
    title: "Advanced Calculus Exercises",
    exercises: [
      {
        title: "Exercise 4.1: Advanced Differentiation",
        type: "Practice",
        instructions: "Differentiate using appropriate rules",
        questions: [
          "y = (3x + 1)⁵ (chain rule)",
          "y = x² sin x (product rule)",
          "y = (x² + 1)/(x - 1) (quotient rule)",
          "Find d²y/dx² for y = x⁴ - 3x² + 2",
          "Implicitly differentiate: x² + y² = 25"
        ]
      },
      {
        title: "Exercise 4.2: Integration Applications",
        type: "Application",
        instructions: "Solve each problem",
        questions: [
          "Find the volume when y = x², 0 ≤ x ≤ 2 is rotated about the x-axis",
          "Solve dy/dx = 2x, given y = 3 when x = 1",
          "Solve dy/dx = y, given y = 2 when x = 0",
          "Find the area between y = sin x and y = cos x from x = 0 to x = π/4",
          "The population P grows according to dP/dt = 0.05P. If P₀ = 1000, find P(10)"
        ]
      }
    ]
  }
};

export default year11MathematicsUnitTests;
